import { initProjectConfigData } from "../data/initialize/projectConfig.data";
import { IProjectConfig, IStreets } from "../interface/config/project-config.interface";

export enum ProjectConfigActionKind {
    SET_PROJECT_ID = 'SET_PROJECT_ID',
    LOAD_PROJECT_CONFIG = 'LOAD_PROJECT_CONFIG',
    SET_STREETS = 'SET_STREETS',
    RESET = 'RESET',
}

type ProjectConfigAction = {
    type: ProjectConfigActionKind.SET_PROJECT_ID;
    payload: {
        projectId: number,
    }
} | {
    type: ProjectConfigActionKind.LOAD_PROJECT_CONFIG;
    payload: {
        projectConfig: IProjectConfig,
    }
} | {
    type: ProjectConfigActionKind.SET_STREETS;
    payload: {
        streets: IStreets[],
    }
} | {
    type: ProjectConfigActionKind.RESET;
};

export function projectConfigReducer(state: IProjectConfig, action: ProjectConfigAction) {

    switch (action.type) {
        case ProjectConfigActionKind.SET_PROJECT_ID:

            return { ...state, projectId: action.payload.projectId };

        case ProjectConfigActionKind.SET_STREETS:

            return { ...state, streets: action.payload.streets };
        case ProjectConfigActionKind.LOAD_PROJECT_CONFIG:

            const projectConfig = action.payload.projectConfig;

            return {
                ...state,
                hadProjectConfigLoaded: true,
                cityLogUrl: projectConfig.cityLogUrl,
                colors: projectConfig.colors,
                hebName: projectConfig.hebName,
                engName: projectConfig.engName,
                makers: projectConfig.makers,
                projectId: projectConfig.projectId,
                streets: projectConfig.streets,
                vehicleGroups: projectConfig.vehicleGroups,
                addRequestPageConfig: projectConfig.addRequestPageConfig,
                homePageConfig: projectConfig.homePageConfig,
            };
        case ProjectConfigActionKind.RESET:


            return { ...initProjectConfigData };
        default:
            return state;
    }
}
